import { useAuth0 } from "@auth0/auth0-vue";

export default defineNuxtRouteMiddleware((to, from) => {
    // See https://auth0.github.io/auth0-vue/functions/useAuth0.html for API
    const client = useAuth0();
    console.log('isAuthenticated: ', client?.isAuthenticated?.value);
    console.log('user: ', client?.user?.value);

    // Using the logic from https://github.com/auth0/auth0-vue/blob/main/src/guard.ts#L10
    if (!unref(client.isAuthenticated)) {
        return navigateTo('/')
    }

})
